<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Remove Bank Account'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'finance-skeleton right-side-scroll-enabled' : 'finance-skeleton'">
      @if (loaded && !connection) {
        <tidy-error-message [text]="errorMessage" />
      }

      @if (loaded && connection) {
        <tidy-card>
          <tidy-row>
            <tidy-text
              [header]="connectionLabel"
              [translate]="false" />
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="'TIDY will stop syncing this account. What should happen to the P&L transactions that came from it?'" />
          </tidy-row>
        </tidy-card>

        <tidy-card>
          <tidy-row class="field-bottom-padding">
            <tidy-radio-button
              [label]="'P&L transactions from this bank'"
              formControlName="transactions"
              [form]="form.controls.transactions"
              [items]="transactionItems"
              [submitted]="submitted"
              [errorMessage]="'Please choose an option'" />
          </tidy-row>
        </tidy-card>

        @if (errorMessage) {
          <tidy-error-message [text]="errorMessage" />
        }

        <tidy-button
          [text]="'Remove Bank Account'"
          [action]="boundRemove"
          [disabled]="saving"
          class="primary" />

        <tidy-button
          [text]="'Cancel'"
          [action]="boundCancel"
          class="secondary" />
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
